import { Pipe, PipeTransform } from '@angular/core';
import { ProfileService } from 'src/app/core/providers';

@Pipe({
  name: 'translateLabel',
  standalone: false,
})
export class TranslateLabelPipe implements PipeTransform {
  constructor(private profileService: ProfileService) {}

  transform(value: string, replacements: any[]): unknown {
    return this.getLabelTranslation(value, replacements);
  }

  private getLabelTranslation = (value: string, replacements?: any[]) => {
    return this.profileService.getLabelTranslation(value, replacements);
  };
}
